import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../../configs/config.common';
import HybridButtonTwo from '../../shared/HybridButtonTwo/hybrid.button.two.vue';
import HybridBasicLayout from '../../layout/basic/hybrid.basic.layout.vue';
import { CallNative } from '../../../services/EpicContextService/call.native';
import { UserInfoDelegate } from '../../services/DataDelegate/UserDelegate/user.info.delegate';
import { AxiosPromise } from '../../../utils/axios.promise';

@Component({
    components: {
        'layout': HybridBasicLayout,
        HybridButtonTwo
    }
})
export default class HybridCouponPaymentStatus extends Vue {
    public configs = new CommonConfig();
    public userInfoDelegate = new UserInfoDelegate();
    public fjjUserId: any;
    public respartnerId: any;
    public couponIns: any;

    public created() {
        CallNative.setNativeNavTitle('交易状态', 'Payment Status');
    }

    public mounted() {
    }
    @Watch('globalPudge', { immediate: true, deep: true })
    public async onEpicContext(val: any, oldVal: any) {
        const couponId = localStorage.getItem('rifo_coupon_id');
        if (val.context) {
            const fjjUserId = val.getParam('fjjUserId');
            if (fjjUserId) {
                this.fjjUserId = fjjUserId;
                const userInfo = await this.userInfoDelegate.getUserInfo(this.fjjUserId);
                this.respartnerId = userInfo.resPartnerId;
                const couponApi = this.configs.couponService;
                const url = `${couponApi}/coupon/detailwithIns?couponId=${couponId}&partnerId=${this.respartnerId}`;
                const fetched = await AxiosPromise.get(url);
                if (fetched.errorCode === 200) {
                    const data = fetched.data;
                    const ins = data.ins;
                    if (ins && ins.length) {
                        this.couponIns = ins[0];
                    }
                }
            }

        }
    }
    public async goAppointment() {
        if (this.$route.query.id1) {
            this.$router.push(`/hybrid/services/appointment/${this.$route.query.id1}`);
        } else {
            if (this.couponIns) {
                this.$router.push(`/hybrid/services/appointment/${this.couponIns.id}`);
            }
        }
    }
    public goMyCoupons() {
        this.$router.push(`/hybrid/coupon/my/coupons`);
    }

    public closeView() {
        CallNative.runNativeFun('nativeGoMe');
    }
    public getRifoDesign(str: string) {
        return `${this.configs.rifoDesignAssetsUrl}/${str}`;
    }
}
